import React from 'react';
import { AccordionContainer } from '../../../../../../common/components/accordion/accordion.module';
import { InputContainer } from '../../../../../../common/components/form/form.module';

export const AccountLedgerTaxInfoComponent = ({ onInnerFormChange, selectedAccountLedgers }: any) => (
  <>
    <AccordionContainer
      child={
        <div className=' grid md:grid-cols-3 lg:grid-cols-4 gap-4'>
          <InputContainer
            label="GST Number"
            name="GSTNumber"
            onValueChange={(event: any) => {
              onInnerFormChange(
                event.target.value,
                'TaxRegistration.GSTNumber',
                selectedAccountLedgers?.TaxRegistration
              )
            }}
            type="text"
            value={selectedAccountLedgers?.TaxRegistration?.GSTNumber}
          />
          <InputContainer
            label="PAN Number"
            name="PANNumber"
            onValueChange={(event: any) => {
              onInnerFormChange(
                event.target.value,
                'TaxRegistration.PANNumber',
                selectedAccountLedgers?.TaxRegistration
              )
            }}
            type="text"
            value={selectedAccountLedgers?.TaxRegistration?.PANNumber}
          />
          <InputContainer
            label="TIN Number"
            name="TINNumber"
            onValueChange={(event: any) => {
              onInnerFormChange(
                event.target.value,
                'TaxRegistration.TINNumber',
                selectedAccountLedgers?.TaxRegistration
              )
            }}
            type="text"
            value={selectedAccountLedgers?.TaxRegistration?.TINNumber}
          />
        </div>
      }
      expandedPanel="Tax Information"
      headerTitle="Tax Information"
    />
  </>
 )

 export default AccountLedgerTaxInfoComponent;